// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"e3a74a6c","55":"6c6b8ff7","147":"80c918a4","453":"a6a9deae","599":"01cefdc9","780":"8fbbda8c"}[chunkId] + ".chunk.js";
};